export enum UserRole {
  User = 'user',
  Admin = 'admin',
}

export enum QuestMissionStatus {
  Created = 'CREATED',
  PendingReverification = 'PENDING_REVERIFICATION',
  Verified = 'VERIFIED',
  PreVerified = 'PRE_VERIFIED',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED',
  AutoApproved = 'AUTO_APPROVED',
  Rejected = 'REJECTED',
  Approved = 'APPROVED',
}

export enum QuestMissionType {
  OnceOff = 'ONCE_OFF',
  Recurring = 'RECURRING',
  MissionBonus = 'MISSION_BONUS',
  QuestBonus = 'QUEST_BONUS',
  ProjectBonus = 'PROJECT_BONUS',
  Retrospective = 'RETROSPECTIVE',
}

export type MissionProof = {
  createdAt: string
  status: QuestMissionStatus
  details: {
    answer: {
      filesUploaded: string[]
      textAnswer: string
    }
  }
}

export type UserMission = {
  strapiProjectId: string
  strapiQuestId: string
  strapiMissionId: string
  status: QuestMissionStatus
  type: QuestMissionType
  earnedXp: number
  proofs: MissionProof[]
}

export type UserRewardsAggregatedData = {
  xpSummary: {
    // xp earned but not yet redeemed
    currentXp?: number | string

    // xp redeemed by user
    redeemedXp?: number | string

    // total xp earned by user (current + redeemed)
    lifetimeXp?: number | string
    questBonusXp?: number
    projectBonusXp?: number
    kolBonusXp?: number
    launchPartyWinnersBonusXp?: number
    raidBonusXp?: number
    baseLineMissionsXp?: number
  }
  wlthSummary: {
    earnedWlth?: number
    claimedWlth?: number
    availableToClaimWlth?: number
  }
  quests: {
    // quests where at least one mission is completed, but not all missions are completed
    // (it means that user has to complete rest of missions to complete whole quest)
    activeQuests: number | string

    // quests where all missions has proof sent, but not yet verified
    completedQuests: number | string

    // quests where all missions has proof sent and verified
    verifiedQuests: number

    // quests not started yet
    inactiveQuests: number | string

    // activeQuests + completedQuests + inactiveQuests
    totalQuests: number | string
  }
  completedProjects: string[]
  userMissions: UserMission[]
}

export enum SocialValidationStatus {
  PENDING = 'PENDING',
  VALIDATED = 'VALIDATED',
  REJECTED = 'REJECTED',
  EMPTY = 'EMPTY',
}

export type UserSocial = {
  username: string
  validationStatus: string
}

export type UserSocials = {
  twitter?: UserSocial
  discord?: UserSocial
  telegram?: UserSocial
}

export type UserMeta = {
  firstLoginDate?: string | null
  latestLoginDate?: string | null
  termsAckVersionId?: string | null
  termsAcknowledgedAt?: string | null
}

export type User = {
  uuid: string
  email: string
  name: string
  emailVerified: boolean
  role: UserRole
  // todo replace when api is complete
  avatar: string
  rewardsState: UserRewardsAggregatedData
  socials: UserSocials
  referralCodeUser?: string | null
  meta?: UserMeta
}

export type SocialStatus = {
  authenticated: boolean
  provider: string
  user: {
    id: string
    username: string
  }
}
